(function () {
  'use strict';

  if (window.__amourConciergeCartReady) return;
  window.__amourConciergeCartReady = true;

  function initConciergeCart() {
    var drawer = document.querySelector('[data-amour-cart-drawer]');
    if (!drawer) return;

    var root = drawer.dataset.cartRoot || '/';
    if (root.slice(-1) !== '/') root += '/';
    var moneyFormat = drawer.dataset.moneyFormat || window.money_format || '${{amount}}';
    var titleNode = drawer.querySelector('[data-amour-cart-title]');
    var deliveryNode = drawer.querySelector('[data-amour-cart-delivery]');
    var deliveryTextNode = drawer.querySelector('[data-amour-cart-delivery-text]');
    var itemsNode = drawer.querySelector('[data-amour-cart-items]');
    var emptyNode = drawer.querySelector('[data-amour-cart-empty]');
    var conciergeNode = drawer.querySelector('[data-amour-cart-concierge]');
    var footerNode = drawer.querySelector('[data-amour-cart-footer]');
    var subtotalNode = drawer.querySelector('[data-amour-cart-subtotal]');
    var savingsRow = drawer.querySelector('[data-amour-cart-savings-row]');
    var savingsNode = drawer.querySelector('[data-amour-cart-savings]');
    var totalNode = drawer.querySelector('[data-amour-cart-total]');
    var installmentNode = drawer.querySelector('[data-amour-cart-installment]');
    var liveNode = drawer.querySelector('[data-amour-cart-live]');
    var errorNode = drawer.querySelector('[data-amour-cart-error]');
    var errorTextNode = drawer.querySelector('[data-amour-cart-error-text]');
    var retryButton = drawer.querySelector('[data-amour-cart-retry]');
    var initialNode = drawer.querySelector('[data-amour-cart-initial]');
    var lastFocused = null;
    var lastAction = null;
    var cart = null;

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function formatMoney(cents) {
      var value = Number(cents || 0) / 100;
      var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);

      function withDelimiters(number, precision, thousands, decimal) {
        var fixed = Number(number || 0).toFixed(precision);
        var parts = fixed.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return precision ? parts[0] + decimal + parts[1] : parts[0];
      }

      if (!match) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
          }).format(value);
        } catch (error) {
          return value.toFixed(2);
        }
      }

      var token = match[1];
      var formatted;
      if (token === 'amount_no_decimals') formatted = withDelimiters(value, 0, ',', '.');
      else if (token === 'amount_with_comma_separator') formatted = withDelimiters(value, 2, '.', ',');
      else if (token === 'amount_no_decimals_with_comma_separator') formatted = withDelimiters(value, 0, '.', ',');
      else if (token === 'amount_with_space_separator') formatted = withDelimiters(value, 2, ' ', ',');
      else if (token === 'amount_no_decimals_with_space_separator') formatted = withDelimiters(value, 0, ' ', ',');
      else if (token === 'amount_with_apostrophe_separator') formatted = withDelimiters(value, 2, "'", '.');
      else formatted = withDelimiters(value, 2, ',', '.');

      return moneyFormat.replace(match[0], formatted);
    }

    function imageUrl(item) {
      var source = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
      if (!source) return '';
      if (/([?&])width=\d+/.test(source)) return source.replace(/([?&])width=\d+/, '$1width=420');
      return source + (source.indexOf('?') === -1 ? '?width=420' : '&width=420');
    }

    function deliveryDates() {
      var start = new Date();
      var end = new Date();
      start.setDate(start.getDate() + 6);
      end.setDate(end.getDate() + 13);
      var locale = document.documentElement.lang || 'en';
      var formatter = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' });
      return formatter.format(start) + '–' + formatter.format(end);
    }

    function setBusy(isBusy) {
      drawer.classList.toggle('is-busy', isBusy);
      Array.prototype.forEach.call(drawer.querySelectorAll('[data-amour-cart-remove]'), function (control) {
        control.disabled = isBusy;
      });
      drawer.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    }

    function showError(message) {
      if (errorTextNode) errorTextNode.textContent = message || drawer.dataset.updateError;
      if (errorNode) errorNode.hidden = false;
      if (liveNode) liveNode.textContent = message || drawer.dataset.updateError;
    }

    function clearError() {
      if (errorNode) errorNode.hidden = true;
    }

    function renderLine(item) {
      var options = Array.isArray(item.options_with_values) ? item.options_with_values.map(function (option) { return option.value; }).filter(Boolean) : [];
      var originalLinePrice = item.original_line_price == null ? item.final_line_price : item.original_line_price;
      var finalLinePrice = item.final_line_price == null ? item.line_price : item.final_line_price;
      var saving = Math.max(originalLinePrice - finalLinePrice, 0);
      var optionMarkup = options.length ? '<p class="amour-cart-line__options">' + options.map(escapeHtml).join(escapeHtml(drawer.dataset.optionSeparator || ' · ')) + '</p>' : '';
      var originalMarkup = originalLinePrice > finalLinePrice ? '<s>' + formatMoney(originalLinePrice) + '</s>' : '';
      var savingMarkup = saving > 0 ? '<span>' + escapeHtml(drawer.dataset.saveLabel) + ' ' + formatMoney(saving) + '</span>' : '';
      var productTitle = item.product_title || item.title || '';
      var productUrl = item.url || '#';
      var lineKey = escapeHtml(item.key);
      return '<li class="amour-cart-line" data-amour-cart-line data-line-key="' + lineKey + '">' +
        '<div class="amour-cart-line__main">' +
          '<a class="amour-cart-line__image" href="' + escapeHtml(productUrl) + '"><img src="' + escapeHtml(imageUrl(item)) + '" width="210" height="210" alt="' + escapeHtml(productTitle) + '" loading="eager"></a>' +
          '<div class="amour-cart-line__details">' +
            '<a class="amour-cart-line__title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(productTitle) + '</a>' +
            optionMarkup +
            '<div class="amour-cart-line__prices"><strong>' + formatMoney(finalLinePrice) + '</strong>' + originalMarkup + savingMarkup + '</div>' +
            '<button class="amour-cart-line__remove" type="button" data-amour-cart-remove>' + escapeHtml(drawer.dataset.removeLabel) + '</button>' +
          '</div>' +
        '</div>' +
      '</li>';
    }

    function render(nextCart) {
      cart = nextCart;
      var count = Number(cart.item_count || 0);
      var isEmpty = count === 0;
      var title = count === 1 ? drawer.dataset.titleOne : (drawer.dataset.titleOther || '').replace('{{ count }}', count).replace('__COUNT__', count);
      var totalSaving = Math.max((cart.original_total_price || 0) - (cart.total_price || 0), 0);

      if (titleNode) titleNode.textContent = title;
      Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (node) { node.textContent = count; });
      if (deliveryNode) deliveryNode.hidden = isEmpty;
      if (deliveryTextNode) deliveryTextNode.textContent = (drawer.dataset.deliveryTemplate || '').replace('__DATES__', deliveryDates());
      if (itemsNode) {
        itemsNode.hidden = isEmpty;
        itemsNode.innerHTML = isEmpty ? '' : cart.items.map(renderLine).join('');
      }
      if (emptyNode) emptyNode.hidden = !isEmpty;
      if (conciergeNode) conciergeNode.hidden = isEmpty;
      if (footerNode) footerNode.hidden = isEmpty;
      if (subtotalNode) subtotalNode.textContent = formatMoney(cart.original_total_price || cart.items_subtotal_price || 0);
      if (savingsRow) savingsRow.hidden = totalSaving <= 0;
      if (savingsNode) savingsNode.textContent = '−' + formatMoney(totalSaving);
      if (totalNode) totalNode.textContent = formatMoney(cart.total_price || 0);
      if (installmentNode) installmentNode.textContent = formatMoney(Math.round((cart.total_price || 0) / 3));
      clearError();
    }

    function changeLine(key, quantity) {
      lastAction = function () { return changeLine(key, quantity); };
      setBusy(true);
      clearError();
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      }).then(function (response) {
        if (!response.ok) throw new Error(drawer.dataset.updateError);
        return response.json();
      }).then(function (nextCart) {
        render(nextCart);
        if (liveNode) liveNode.textContent = drawer.dataset.updateSuccess;
      }).catch(function (error) {
        showError(error && error.message ? error.message : drawer.dataset.updateError);
      }).finally(function () {
        setBusy(false);
      });
    }

    drawer.addEventListener('click', function (event) {
      var line = event.target.closest('[data-amour-cart-line]');
      if (!line || !cart) return;
      var key = line.dataset.lineKey;
      var item = cart.items.filter(function (candidate) { return candidate.key === key; })[0];
      if (!item) return;
      if (event.target.closest('[data-amour-cart-remove]')) changeLine(key, 0);
    });

    if (retryButton) retryButton.addEventListener('click', function () { if (lastAction) lastAction(); });

    function focusableItems() {
      return Array.prototype.slice.call(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled])')).filter(function (item) {
        return item.offsetParent !== null;
      });
    }

    document.addEventListener('pointerdown', function (event) {
      if (event.target.closest('[data-cart-toggle]')) drawer.classList.add('is-pointer-open');
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.target.closest('[data-cart-toggle]') && (event.key === 'Enter' || event.key === ' ')) {
        drawer.classList.remove('is-pointer-open');
      }
    }, true);

    function syncOpenState() {
      var isOpen = document.documentElement.classList.contains('cart-show');
      drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      if (isOpen) {
        lastFocused = document.activeElement;
        window.requestAnimationFrame(function () {
          var close = drawer.querySelector('.amour-cart-drawer__close');
          if (close) close.focus();
        });
      } else if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
        lastFocused = null;
        drawer.classList.remove('is-pointer-open');
      }
    }

    new MutationObserver(syncOpenState).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('keydown', function (event) {
      if (!document.documentElement.classList.contains('cart-show') || event.key !== 'Tab') return;
      var items = focusableItems();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    try {
      render(JSON.parse(initialNode.textContent));
    } catch (error) {}
    syncOpenState();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initConciergeCart);
  else initConciergeCart();
})();
